export default {
  extra_info: {
    sofort: {
      title: 'Important info',
      item_1: 'Our software provider FoodAmigos (Amigo Technologies) works on our behalf with Sofort',
      item_2: 'Sofort will withdraw 1 EUR from your account and refund you the money to verify your account',
    },
  },
};
